import React from 'react';
import cx from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import { useAppSelector } from 'src/redux/store';
import Authentication from 'utils/authentication';

import { getOAuthResultStatus, OAUTH_RESULT_STATUS } from './helpers';
import styles from './styles.scss';

const OAuthResult = ({ history, location }) => {
  const intl = useIntl();
  const { theme } = useAppSelector((state) => state.theme);
  const resultStatus = getOAuthResultStatus(location.search);
  const hasSession = Authentication.hasSession();
  const isSuccess = resultStatus === OAUTH_RESULT_STATUS.SUCCESS;

  const returnToIntegrations = () => {
    history.replace('/dashboard', { openBankIntegrations: true });
  };

  const returnToDashboard = () => {
    history.replace('/dashboard');
  };

  const content = {
    [OAUTH_RESULT_STATUS.SUCCESS]: {
      title: intl.formatMessage({
        id: 'oauthResult.success.title',
        defaultMessage: 'Yetkilendirme tamamlandı',
      }),
      description: intl.formatMessage({
        id: hasSession ? 'oauthResult.success.description' : 'oauthResult.success.description.guest',
        defaultMessage: hasSession
          ? 'Banka, yetkilendirme adımının başarıyla tamamlandığını bildirdi. Güncel bağlantı durumunu entegrasyonlar listesinden kontrol edebilirsiniz.'
          : 'Banka, yetkilendirme adımının başarıyla tamamlandığını bildirdi.',
      }),
      symbol: '✓',
    },
    [OAUTH_RESULT_STATUS.ERROR]: {
      title: intl.formatMessage({
        id: 'oauthResult.error.title',
        defaultMessage: 'Bağlantı tamamlanamadı',
      }),
      description: intl.formatMessage({
        id: 'oauthResult.error.description',
        defaultMessage:
          'Banka yetkilendirmesi tamamlanamadı veya işlem iptal edildi. Tekrar deneyebilir ya da güncel durumu entegrasyonlar listesinden kontrol edebilirsiniz.',
      }),
      symbol: '!',
    },
  }[resultStatus];

  return (
    <main
      className={cx(styles.page, styles[`page-${theme}`], {
        [styles['page-standalone']]: !hasSession,
      })}>
      <section className={cx(styles.card, styles[`card-${theme}`])}>
        <div role={isSuccess ? 'status' : 'alert'} aria-live={isSuccess ? 'polite' : 'assertive'}>
          <div className={cx(styles.icon, styles[`icon-${resultStatus}`])} aria-hidden="true">
            {content.symbol}
          </div>
          <p className={styles.eyebrow}>
            <FormattedMessage id="oauthResult.eyebrow" defaultMessage="Banka Entegrasyonu" />
          </p>
          <h1>{content.title}</h1>
          <p className={styles.description}>{content.description}</p>
        </div>

        {hasSession && (
          <>
            <div className={styles.actions}>
              <button type="button" className={styles.primary} onClick={returnToIntegrations}>
                <FormattedMessage id="oauthResult.action.integrations" defaultMessage="Entegrasyonlara Dön" />
              </button>
              <button type="button" className={styles.secondary} onClick={returnToDashboard}>
                <FormattedMessage id="oauthResult.action.dashboard" defaultMessage="Genel Bakışa Dön" />
              </button>
            </div>
            <p className={styles.note}>
              <span aria-hidden="true">ⓘ</span>
              <FormattedMessage
                id="oauthResult.note"
                defaultMessage="Entegrasyonlara döndüğünüzde bağlantının son durumu sunucudan yeniden alınır."
              />
            </p>
          </>
        )}
      </section>
    </main>
  );
};

export default OAuthResult;
